import React, { useState, useEffect } from 'react';
import { ArrowSmRightIcon } from '@heroicons/react/solid';
import { APPLICATION_URL } from '../../constants';

export default function FastFairFussFree() {
  const [active, setActive] = useState('Fast');
  useEffect(() => {
    const intervalId = setInterval(() => {
      setActive((current) =>
        current === 'Fast' ? 'Fair' : current === 'Fair' ? 'Fuss-Free' : 'Fast'
      );
    }, 4000);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <header className="flex justify-center items-center px-16 py-12 bg-avenue-slate-500 max-md:px-5">
      <div className="flex flex-col items-center mt-2.5 max-w-full">
        <h1
          className="self-stretch text-6xl tracking-tighter text-center text-white max-md:max-w-full max-md:text-4xl"
          aria-label="Header Title"
        >
          What good looks like
          <div className="relative inline-block -top-1 xl:-top-2">
            <ArrowSmRightIcon className="h-5 lg:h-6 xl:h-8" />
          </div>
        </h1>
        <div className="sr-only">Fast, fair, and fuss-free.</div>

        <p className="mt-8 text-4xl tracking-tight text-center text-white whitespace-nowrap font-[350] leading-[50.4px]">
          <span
            className={`transition-colors duration-700 ${
              active === 'Fast' ? 'text-avenue-blue-500' : ''
            }`}
          >
            Fast
          </span>
          ,
          <span
            className={`transition-colors duration-700 ${
              active === 'Fair' ? 'text-avenue-blue-500' : ''
            }`}
          >
            {' '}
            fair
          </span>
          , and
          <span
            className={`transition-colors duration-700 ${
              active === 'Fuss-Free' ? 'text-avenue-blue-500' : ''
            }`}
          >
            {' '}
            fuss-free
          </span>
          .
        </p>

        <div className="mt-11 max-w-full max-md:mt-10 justify-center items-center">
          <div
            className={`flex gap-5 max-md:flex-col max-md:gap-0 transition-colors  duration-700 xl:h-40 ${
              active === 'Fast' ? 'opacity-100' : 'hidden'
            }`}
          >
            <div className="flex flex-col w-[31%] max-md:ml-0 max-md:w-full">
              <div className="flex flex-col text-center whitespace-nowrap max-md:mt-10">
                <h2
                  className="text-6xl font-bold tracking-tighter text-avenue-blue-500 leading-[69.3px] max-md:text-4xl"
                  aria-label="Apply In 5 Minutes"
                >
                  5 min
                </h2>
                <div className="self-center mt-3.5 text-2xl tracking-tight leading-6 text-white">
                  to apply
                </div>
              </div>
            </div>
            <div className="flex flex-col ml-5 w-[41%] max-md:ml-0 max-md:w-full">
              <div className="flex flex-col grow text-center whitespace-nowrap max-md:mt-10">
                <div className="flex flex-col pr-1.5 pl-3">
                  <h2
                    className="text-6xl font-bold tracking-tighter text-avenue-blue-500 leading-[69.3px] max-md:text-4xl"
                    aria-label="Pre-Approval in 30 Seconds"
                  >
                    30 secs
                  </h2>
                  <div className="mt-3.5 text-2xl tracking-tight leading-6 text-white">
                    pre-approval
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-col ml-5 w-[28%] max-md:ml-0 max-md:w-full">
              <div className="flex flex-col text-center whitespace-nowrap max-md:mt-10">
                <h2
                  className="text-6xl font-bold tracking-tighter text-avenue-blue-500 leading-[69.3px] max-md:text-4xl"
                  aria-label="Issued in 24 Hours"
                >
                  24 hours
                </h2>
                <div className="mt-3.5 text-2xl tracking-tight leading-6 text-white">
                  to issue<sup>1</sup>
                </div>
              </div>
            </div>
          </div>

          {/* Fair */}
          <div
            className={`flex flex-row flex-wrap justify-center gap-5 max-md:flex-col max-md:gap-0 transition-colors duration-700 xl:h-40  ${
              active === 'Fair' ? 'opacity-100' : 'hidden'
            }`}
          >
            <div className="flex flex-col max-md:ml-0 max-md:w-full">
              <div className="flex flex-col text-center whitespace-nowrap max-md:mt-10">
                <h2
                  className="text-6xl font-bold tracking-tighter text-avenue-blue-500 leading-[69.3px] max-md:text-4xl"
                  aria-label="Apply In 5 Minutes"
                >
                  3.25% p.a
                </h2>
                <div className="self-center mt-3.5 text-2xl tracking-tight leading-6 text-white">
                  interest paid to you<sup>2</sup>
                </div>
              </div>
            </div>
            <div className="flex flex-col ml-5 max-md:ml-0 max-md:w-full">
              <div className="flex flex-col grow text-center whitespace-nowrap max-md:mt-10">
                <div className="flex flex-col pr-1.5 pl-3">
                  <h2
                    className="text-6xl font-bold tracking-tighter text-avenue-blue-500 leading-[69.3px] max-md:text-4xl"
                    aria-label="Pre-Approval in 30 Seconds"
                  >
                    $0
                  </h2>
                  <div className="mt-3.5 text-2xl tracking-tight leading-8 text-white">
                    establishment fees <br />
                    for a limited time
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-col ml-5  max-md:ml-0 max-md:w-full">
              <div className="flex flex-col text-center whitespace-nowrap max-md:mt-10">
                <h2
                  className="text-6xl font-bold tracking-tighter text-avenue-blue-500 leading-[69.3px] max-md:text-4xl"
                  aria-label="Issued in 24 Hours"
                >
                  100%
                </h2>
                <div className="mt-3.5 text-2xl tracking-tight leading-6 text-white">
                  government guaranteed<sup>3</sup>
                </div>
              </div>
            </div>
            <div className="flex flex-col ml-5 max-md:ml-0 max-md:w-full">
              <div className="flex flex-col text-center whitespace-nowrap max-md:mt-10">
                <h2
                  className="text-6xl font-bold tracking-tighter text-avenue-blue-500 leading-[69.3px] max-md:text-4xl"
                  aria-label="Issued in 24 Hours"
                >
                  0
                </h2>
                <div className="mt-3.5 text-2xl tracking-tight leading-6 text-white">
                  properties as security
                </div>
              </div>
            </div>
          </div>

          {/* Fuss Free */}
          <div
            className={`flex flex-row gap-5 max-md:flex-col max-md:gap-0 transition-colors duration-700 xl:h-40 ${
              active === 'Fuss-Free' ? 'opacity-100' : 'hidden'
            }`}
          >
            <div className="flex flex-col max-md:ml-0 max-md:w-full">
              <div className="flex flex-col text-center whitespace-nowrap max-md:mt-10">
                <h2
                  className="text-6xl font-bold tracking-tighter text-avenue-blue-500 leading-[69.3px] max-md:text-4xl"
                  aria-label="Apply In 5 Minutes"
                >
                  100%
                </h2>
                <div className="self-center mt-3.5 text-2xl tracking-tight leading-6 text-white">
                  digital application process
                </div>
              </div>
            </div>
            <div className="flex flex-col ml-5 max-md:ml-0 max-md:w-full">
              <div className="flex flex-col grow text-center whitespace-nowrap max-md:mt-10">
                <div className="flex flex-col pr-1.5 pl-3">
                  <h2
                    className="text-6xl font-bold tracking-tighter text-avenue-blue-500 leading-[69.3px] max-md:text-4xl"
                    aria-label="Pre-Approval in 30 Seconds"
                  >
                    0
                  </h2>
                  <div className="mt-3.5 text-2xl tracking-tight leading-8 text-white">
                    lengthy credit <br />
                    assessments
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-col ml-5 max-md:ml-0 max-md:w-full">
              <div className="flex flex-col grow text-center whitespace-nowrap max-md:mt-10">
                <div className="flex flex-col pr-1.5 pl-3">
                  <h2
                    className="text-6xl font-bold tracking-tighter text-avenue-blue-500 leading-[69.3px] max-md:text-4xl"
                    aria-label="Pre-Approval in 30 Seconds"
                  >
                    0
                  </h2>
                  <div className="mt-3.5 text-2xl tracking-tight leading-6 text-white">
                    director’s guarantees
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center my-6 max-md:mt-10">
            <a
              id={"apply-now-btn"}
              href={APPLICATION_URL}
              className="justify-center px-8 py-4 mt-12 text-base font-bold tracking-normal text-white bg-orange-500 rounded-md max-md:px-5 max-md:mt-10 shadow-lg transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300 max-width:100px display:block"
              type="submit"
              aria-label="Apply Now"
              target="_self"
              rel="noreferrer"
            >
              Apply now
              <span className="tracking-normal text-white"> →</span>
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}
